import type { LucideIcon } from "lucide-react";

export type StatTone = "accent" | "ink" | "success" | "info";

export interface StatTile {
  key: string;
  label: string;
  value: string | number;
  icon: LucideIcon;
  tone: StatTone;
  caption?: string;
}

interface StatsStripProps {
  tiles: StatTile[];
  loading?: boolean;
  columns?: 3 | 4;
}

export function StatsStrip({ tiles, loading, columns = 4 }: StatsStripProps) {
  const gridClass =
    columns === 3 ? "loyalty-stats-grid loyalty-stats-grid--3" : "loyalty-stats-grid";

  return (
    <div className={gridClass}>
      {tiles.map((tile) => {
        const Icon = tile.icon;
        return (
          <article
            key={tile.key}
            className={`loyalty-stat-tile loyalty-stat-tile--${tile.tone} ${loading ? "skeleton" : ""}`}
          >
            <div className="loyalty-stat-tile__top">
              <span className="loyalty-stat-tile__icon" aria-hidden>
                <Icon className="h-4 w-4" strokeWidth={2.25} />
              </span>
              <span className="loyalty-stat-tile__label">{tile.label}</span>
            </div>
            <p className="loyalty-stat-tile__value">{loading ? "—" : tile.value}</p>
            {tile.caption ? (
              <p className="loyalty-stat-tile__caption">{tile.caption}</p>
            ) : null}
          </article>
        );
      })}
    </div>
  );
}
